import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'i18next';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import AlertModal from '../../ReactComponent/Modal/AlertModal';
import { P } from '../../../theme/typographySitecore';
import RenderField from '../../ReactComponent/RenderField';
import { isEmail, isRequired } from '../../../utils/validator';
import {
  Form, FieldContainer, ButtonContainer, CancelButton, ResetPasswordButton, HeaderContainer, HeaderSummary,
} from './css';
import { requestPasswordReset } from '../../../services/users';

const formName = 'forgotPasswordModalForm';
const ForgotPasswordModalFormFields = {
  UserEmail: 'userEmail',
};

const ForgotPasswordModal = ({
  isOpen, onClose, onSuccess, parentFields, onFailure,
}) => {
  const handleSubmit = (userEmail) => {
    requestPasswordReset(userEmail)
      .then((res) => {
        if (res.status === 200) {
          onSuccess();
        }
      }).catch(() => {
        onFailure();
      });
  };

  const header = () => (
    <HeaderContainer>
      <div>{t('ForgotPassword')}</div>
      <HeaderSummary field={parentFields.forgotPasswordModalSummary} />
    </HeaderContainer>
  );

  const footer = () => (
    <P field={parentFields.logInSupportLinkText} />
  );

  return (
    <AlertModal
      isOpen={isOpen}
      onClose={onClose}
      header={header}
      // eslint-disable-next-line react/no-unstable-nested-components
      content={() => <ForgotPasswordModalForm onClose={onClose} handleSubmit={handleSubmit} />}
      footer={footer}
    />
  );
};

export default ForgotPasswordModal;

let ForgotPasswordModalForm = ({
  invalid, pristine, onClose, handleSubmit, userEmail,
}) => (
  <Form>

    <FieldContainer>
      <Field
        name={ForgotPasswordModalFormFields.UserEmail}
        type="text"
        component={RenderField}
        label={t('EmailId')}
        validate={[isRequired, isEmail]}
      />
    </FieldContainer>

    <ButtonContainer>
      <CancelButton
        type="button"
        smallWidth
        onClick={onClose}
      >
        {t('Cancel')}
      </CancelButton>
      <ResetPasswordButton
        type="button"
        smallWidth
        iconRightArrow
        disabled={invalid || pristine}
        onClick={() => handleSubmit(userEmail)}
      >
        {t('ResetPassword')}
      </ResetPasswordButton>
    </ButtonContainer>

  </Form>
);

ForgotPasswordModalForm = reduxForm({
  form: formName,
})(ForgotPasswordModalForm);

const selector = formValueSelector(formName);

ForgotPasswordModalForm = connect(
  (state) => {
    const userEmail = selector(state, ForgotPasswordModalFormFields.UserEmail);
    return {
      userEmail,
    };
  },
)(ForgotPasswordModalForm);

ForgotPasswordModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  onFailure: PropTypes.func,
  parentFields: PropTypes.shape({
    forgotPasswordModalSummary: PropTypes.object,
    logInSupportLinkText: PropTypes.object,
  }),
};

ForgotPasswordModalForm.propTypes = {
  invalid: PropTypes.bool,
  pristine: PropTypes.bool,
  onClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  userEmail: PropTypes.string,
};
